<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Tags</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="false"
				[hideCancel]="true"
				[hideDelete]="true"
				[hideSave]="true"
				(onAddChange)="newTag()"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>

	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="venueService.subscriptionOOTags.value"
		[loading]="!venueService.subscriptionOOTags.value"
		[globalFilterFields]="app.keys(venueService.subscriptionOOTags.value)"
		[scrollable]="true"
		[rows]="100"
		scrollHeight="700px"
		[virtualScroll]="true"
		[virtualRowHeight]="40"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th>Name</th>
				<th>Preview</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr (click)="tagSelected = rec">
				<td>
					{{ rec.name }}
				</td>
				<td class="d-flex w-100">
					<div class="mx-auto">
						<p-tag [value]="rec.name" [severity]="rec.severity" [rounded]="true" styleClass="mx-auto"></p-tag>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<p-dialog *ngIf="tagSelected" [(visible)]="tagSelected" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<ng-template pTemplate="header">
		<div class="d-flex">
			<fa-icon [icon]="['far', 'tag']" class="me-4" size="2x"></fa-icon>
			<div class="display-8 ms-1 my-auto">Tag Setup</div>
		</div>
		<p-divider></p-divider>
	</ng-template>
	<div class="p-grid">
		<div class="p-col-12 p-md-6">
			<div>
				<span class="p-float-label mt-4">
					<input pInputText #tagNameInput name="tagNameInput" type="text" [(ngModel)]="tagSelected.name" class="w-100" />
					<label for="tagNameInput">Tag</label>
				</span>
			</div>
			<div class="mt-4">
				<span class="p-float-label">
					<p-dropdown
						#tagSeveritySelect
						[options]="tagSeverities"
						optionLabel="name"
						optionValue="value"
						name="tagSeveritySelect"
						[(ngModel)]="tagSelected.severity"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						filter="true"
						(filterBy)="app.keys(tagSeverities)"
					></p-dropdown>
					<label for="tagSeveritySelect">Tag Type</label>
				</span>
			</div>
		</div>
		<div class="p-col-12 p-md-6">
			<div class="d-flex">
				<div class="display-12 ms-1 my-auto">Preview</div>
				<div class="ms-auto">
					<p-tag [value]="tagSelected.name" [severity]="tagSelected.severity" [rounded]="true"></p-tag>
				</div>
			</div>
			<p-divider></p-divider>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideCancel]=""
			[hideDelete]=""
			[hideSave]=""
			[deletePromptOverride]="true"
			(onCancelChange)="tagSelected = undefined"
			(onDeleteChange)="deleteTag(tagSelected)"
			(onSaveChange)="saveTag(tagSelected); tagSelected = undefined"
			[cancelDisabled]=""
			[deleteDisabled]="!tagSelected.key"
			[saveDisabled]="!tagSelected.name || !tagSelected.severity"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
